export const getNewsletterSource = (pathname: string) => {
  const source = pathname === '/black-friday' ? 'NEWSLETTER_BLACKFRIDAYPAGE' : 'NEWSLETTER';
  return source;
};
